/**
 * Dynamic Array data
 */
export const arrayData = [
	{
		y: 400,
		quarters: [
			{
				x: 'Q1',
				y: 120,
			},
			{
				x: 'Q2',
				y: 90,
			},
			{
				x: 'Q3',
				y: 100,
			},
			{
				x: 'Q4',
				y: 90,
			},
		],
	},
	{
		y: 430,
		quarters: [
			{
				x: 'Q1',
				y: 120,
			},
			{
				x: 'Q2',
				y: 110,
			},
			{
				x: 'Q3',
				y: 90,
			},
			{
				x: 'Q4',
				y: 110,
			},
		],
	},
	{
		y: 448,
		quarters: [
			{
				x: 'Q1',
				y: 70,
			},
			{
				x: 'Q2',
				y: 100,
			},
			{
				x: 'Q3',
				y: 140,
			},
			{
				x: 'Q4',
				y: 138,
			},
		],
	},
	{
		y: 470,
		quarters: [
			{
				x: 'Q1',
				y: 150,
			},
			{
				x: 'Q2',
				y: 60,
			},
			{
				x: 'Q3',
				y: 190,
			},
			{
				x: 'Q4',
				y: 70,
			},
		],
	},
	{
		y: 540,
		quarters: [
			{
				x: 'Q1',
				y: 120,
			},
			{
				x: 'Q2',
				y: 120,
			},
			{
				x: 'Q3',
				y: 130,
			},
			{
				x: 'Q4',
				y: 170,
			},
		],
	},
	{
		y: 580,
		quarters: [
			{
				x: 'Q1',
				y: 170,
			},
			{
				x: 'Q2',
				y: 130,
			},
			{
				x: 'Q3',
				y: 120,
			},
			{
				x: 'Q4',
				y: 160,
			},
		],
	},
];
